import React, { useEffect } from 'react';
import Swal from 'sweetalert2';
import './style.css'; // Import the CSS file

const NotificationPopup = () => {
    useEffect(() => {
        window.addEventListener('popup', handleCustomEvent);
        return () => {
            window.removeEventListener('popup', handleCustomEvent);
        };
    }, []);

    function handleCustomEvent(event) {
        let { message, type } = event.detail.data;

        if (!navigator.onLine) {
            if (type === 'error') {
                type = 'warning';
                message = 'Sin conexión a internet. Esta acción requiere conexión activa.';
            }
        }
        const resolvedType = type || 'info';

        let duration = 30000; // Por defecto 30 segundos (warn, etc.)
        if (resolvedType === 'success' || resolvedType === 'info') {
            duration = 3000; // 3 segundos
        } else if (resolvedType === 'error') {
            duration = 60000; // 60 segundos
        }

        Swal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            showCloseButton: true,
            timer: duration,
            timerProgressBar: true,
            icon: resolvedType, // 'success', 'error', 'warning', 'info', 'question'
            title: message,
            customClass: {
                popup: 'notification-popup-toast',
                title: 'notification-popup-title',
                timerProgressBar: 'notification-popup-progress',
                closeButton: 'notification-popup-close'
            }
        });
    }

    return null; // This component no longer renders anything directly
};

export default NotificationPopup;
